export type DetectedPlatform = "macos" | "windows" | "linux" | "ios" | "android" | "unknown";

export function detectPlatform(): DetectedPlatform {
  if (typeof navigator === "undefined") {
    return "unknown";
  }

  const ua = navigator.userAgent.toLowerCase();

  if (ua.includes("iphone") || ua.includes("ipad") || ua.includes("ipod")) {
    return "ios";
  }
  if (ua.includes("android")) {
    return "android";
  }
  if (ua.includes("mac os x") || ua.includes("macintosh")) {
    return "macos";
  }
  if (ua.includes("windows")) {
    return "windows";
  }
  if (ua.includes("linux")) {
    return "linux";
  }

  return "unknown";
}
